<template>
    <div class="p-3">
        <h3>RL 1.3 Ketersediaan Tempat Tidur</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Ketersediaan Tempat Tidur" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="false" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
            ],
            tableOptions: {
                baseUrl: '/api/identitas-rumah-sakit/ketersediaan-tempat-tidur',
                layout: 'fitColumns',
                responsiveLayout: true,
                addRowPos: 'bottom',
                columns: [
                    {
                        title: "No",
                        field: "id",
                        width: 50,
                        hozAlign: "center",
                    },
                    {
                        title: "Kelas Tempat Tidur",
                        field: "kelas",
                        editor: "input",
                        headerTooltip: "Kelas tempat tidur ruang perawatan sesuai ruangan yang dilaporkan"
                    },
                    {
                        title: "Ruangan",
                        field: "ruangan",
                        headerTooltip: "Nama ruangan tempat tidur. Ruangan yang dimaksud merupakan kamar yang berisi tempat tidur perawatan pasien."
                    },
                    {
                        title: "Jumlah Tempat Tidur Tersedia",
                        field: "tersedia",
                        hozAlign: "center",
                        headerTooltip: "Jumlah kapasitas tempat tidur pasien sesuai kelas dan ruangannya"
                    },
                    {
                        title: "Jumlah Tempat Tidur Terpakai",
                        field: "terpakai",
                        hozAlign: "center",
                        headerTooltip: "Jumlah tempat tidur yang sedang digunakan pasien sesuai kelas dan ruangannya",
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
